import React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Card, CardContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import DropDownMenu from '@/components/DropDownMenu/DropDownMenu';

const PREFIX = 'DesksTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    overflowX: 'auto',
  },

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },
}));

const DesksTable = props => {
  const { className, meetupId, desks, handleDelete, generatePin, ...rest } = props;

  const settings = {
    faceScannerEnabled: 'Сканер лица',
    webCamBarScannerEnabled: 'Встроенный сканер бар-кода',
    actionCheckinEnabled: 'Ставить флаг checkin',
    actionPrintBadgeEnabled: 'Печатать бейдж автоматически',
    dontOpenCard: 'Не открывать карточку посетителя',
  };

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Название</TableCell>
                <TableCell>Тип</TableCell>
                <TableCell>Даты активности</TableCell>
                <TableCell>Действия</TableCell>
                <TableCell>PIN-код входа</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {desks.map(desk => (
                <TableRow className={classes.tableRow} hover key={desk.deskId}>
                  <TableCell>
                    <RouterLink to={'/m/' + meetupId + '/desk/id/' + desk.deskId}>
                      <ListItemText primary={desk.name} />
                    </RouterLink>
                  </TableCell>
                  <TableCell>
                    {{
                      registrationDesk: 'Стойка администратора',
                      accessDesk: 'Контроль доступа',
                      selfServiceDesk: 'Стойка саморегистрации',
                    }[desk.settings.type] || desk.settings.type}
                  </TableCell>
                  <TableCell>
                    {desk.forTest
                      ? 'тестовая стойка'
                      : desk.activeDays.sort().map(date => (
                          <div key={date}>
                            {new Date(date).toLocaleDateString('ru', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </div>
                        ))}
                  </TableCell>
                  <TableCell>
                    {Object.keys(settings)
                      .filter(setting => desk.settings[setting] === true)
                      .map(setting => (
                        <div key={setting}>{settings[setting]}</div>
                      ))}
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={desk.pin} data-test-id='desk-pin' />
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', width: '100px' }}>
                    <DropDownMenu data-test-id='desk-menu'>
                      <MenuItem>
                        <RouterLink to={'/m/' + meetupId + '/desk/id/' + desk.deskId}>
                          <ListItemText primary='Редактировать' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem onClick={() => generatePin(meetupId, desk.deskId)}>
                        <ListItemText primary='Сгенерировать пин-код' />
                      </MenuItem>
                      <MenuItem onClick={() => handleDelete(meetupId, desk.deskId)}>
                        <ListItemText primary='Удалить' />
                      </MenuItem>
                    </DropDownMenu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

DesksTable.propTypes = {
  className: PropTypes.string,
  desks: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
};

export default DesksTable;
